<template>
  <div class="row d-flex justify-content-center job-create-publish">
    <div class="col-12 col-md-10 col-lg-8">

      <div v-if="job.payment_type_id === CREDIT_PAYMENT && !hasEnoughCredits"
           class="text-danger">
        {{$t('job.create.publish.paymentTypeWarning')}}
      </div>

      <cost-calculator :price-data="priceData"
                       class="cost-card__publish"
                       :payment="payment"
                       :get-job-board="getJobBoard"
                       :credit-price="creditPrice"
                       :contracts-balance="contractsBalance"
                       :show-available-credits="job.payment_type_id === CREDIT_PAYMENT"
                       :client="client">
        <section-separator has-border size="lg" slot="title">
          {{$t('job.create.costCalculator.title')}}
        </section-separator>
      </cost-calculator>

      <section-separator has-border size="lg" class="mt-5">
        {{$t('generic.client')}} & {{$t('generic.product')}}
      </section-separator>
      <div class="row">
        <div class="col-sm-6 col-12">
          <h6 class="text-capitalize">{{$t('generic.client')}}</h6>
          <div v-if="client" class="mt-4">
            <div class="d-flex mb-1 flex-column">
              <div>
                <img class="client-image" :src="client.image" alt="">
              </div>
              <span class="card-title">{{client.name}}</span>
            </div>
            <small>{{client.description}}</small>
          </div>
        </div>
        <div class="col-sm-6 col-12">
          <h6 class="text-right text-capitalize">{{$t('generic.product')}}</h6>
          <div class="mt-4" v-if="product">
            <div class="d-flex align-items-center mb-1 justify-content-end">
              <span class="card-title">{{product.name}}</span>
            </div>
          </div>
        </div>
      </div>
      <section-separator has-border size="lg">
        {{$t('generic.jobBoards')}} & {{$t('generic.jobDetails')}}
      </section-separator>
      <div class="row">
        <div class="col-sm-6 col-12">
          <h6 class="text-capitalize">{{$t('generic.jobBoards')}}</h6>
          <div v-for="board in jobBoards" class="job-board__row">
            <span class="card-title">{{board.name}}</span>
            <div>
              <badge type="info">{{board.status}}</badge>
            </div>
          </div>
        </div>
        <div class="col-sm-6 col-12">
          <h6 class="text-capitalize text-right">{{$t('generic.jobDetails')}}</h6>
          <div class="text-right">
            <b>{{$t('generic.title')}}</b>: {{job.title}}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { mapState } from 'vuex'
  import Badge from '@/components/Badge'
  import CostCalculator from './CostCalculator'

  export default {
    name: 'job-create-publish',
    components: {
      Badge,
      CostCalculator
    },
    props: {
      job: {
        type: Object,
        default: () => ({})
      },
      client: {
        type: Object,
        default: () => ({})
      },
      payment: {
        type: Object,
        default: () => ({})
      },
      product: {
        type: Object,
        default: () => ({})
      },
      priceData: {
        type: Object,
        default: () => ({})
      },
      contractsBalance: {
        type: [Array, Object],
        default: () => []
      },
      jobBoards: {
        type: Array,
        default: () => []
      }
    },
    data() {
      return {
        CREDIT_PAYMENT: 2
      }
    },
    computed: {
      ...mapState({
        creditPrice: state => state.config.creditPrice
      }),
      totalPrice () {
        return this.priceData ? this.priceData.price : 0
      },
      totalPriceCredits () {
        if (!this.priceData) {
          return 0
        }
        return Math.round(this.priceData.price / this.creditPrice)
      },
      hasEnoughCredits () {
        let clientCredits = this.client.credits || 0
        return this.totalPriceCredits <= clientCredits
      }
    },
    methods: {
      getJobBoard (id) {
        return this.jobBoards.find(d => d.id === id)
      }
    }
  }
</script>
<style lang="scss" scoped>
  .job-create-publish {
    .client-image {
      height: 32px;
      width: auto;
      margin-right: 10px;
    }
    .cost-card__publish {
      padding: 0;
      margin-top: 0;
    }
    .job-board__row {
      display: flex;
      width: 200px;
      justify-content: space-between;
      height: 40px;
      align-items: center;
      .card-title {
        margin-bottom: 0;
      }
    }
  }
</style>
